module.exports = __webpack_public_path__ + "img/save-btn.c3ec7b91.png";